import { getCookie } from '../others/cookie'
import { isApp } from '../others/devices'

import { reconcileAnonymousId } from './reconcileAnonymousId'

export const getRefusedSegmentIntegrations = (): Record<string, boolean> => {
  const emptyIntegrations = {}

  if (isApp()) {
    return emptyIntegrations
  }

  const axeptioCookie = getCookie('axeptio_cookies')

  if (!axeptioCookie) {
    return emptyIntegrations
  }

  let parsedAxeptioCookie: Record<string, boolean> = {}

  try {
    parsedAxeptioCookie = JSON.parse(unescape(axeptioCookie))
  } catch (_) {
    return emptyIntegrations
  }

  const validatedAxeptioCookies = Object.keys(parsedAxeptioCookie).filter(
    (e) => !e.startsWith('$'),
  )
  const segmentRefusedIntegrations: Record<string, boolean> = {}
  validatedAxeptioCookies.forEach((e) => {
    if (parsedAxeptioCookie[e] === false) {
      segmentRefusedIntegrations[e] = parsedAxeptioCookie[e]
    }
  })
  return segmentRefusedIntegrations
}

export const shouldUseSegment = (
  analytics: SegmentAnalytics.AnalyticsJS & {
    initialized?: boolean
  },
): boolean => {
  if (!analytics || !analytics.initialized) {
    return false
  }

  if (isApp()) {
    reconcileAnonymousId()
    return true
  }

  const authorizedIntegrations = getCookie('axeptio_authorized_vendors')

  if (!authorizedIntegrations) {
    return false
  }

  return (
    unescape(authorizedIntegrations)
      .split(',')
      .filter((e) => e.length > 0).length > 0
  )
}
